/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import OutboundIdentifiersDetailsPanel from './layout';

export default connect()(OutboundIdentifiersDetailsPanel);
